export default {
  date: 'May 16, 2024',
  title: 'New feature release: high-quality ai-produced real estate images',
  description: 'Learn more about how to update your real estate listings and attract more clients',
  id: 'new-feature-release',
  jsx: () => (
    <div class='novelty__text'>
      <p>We are pleased to introduce our new product - "Render set"!</p>
      <p>"Render set" offers the opportunity to purchase high-quality interior renderings of residential properties along with 2D and 3D floor plans.</p>
      <p>Our product "Render set" solves the problem of placing renders on real estate listing websites. Now users can obtain all the necessary visual materials for their listing in one place at an affordable price. Additionally, "Render set" makes it easy to embed virtual tours on any website.</p>
      <p>Our renderings look natural and familiar to the human eye on real estate listing websites, as they closely resemble actual property photos.</p>
      <p>The new "Render set" will be available at the end of May on our website!</p>
    </div>
  ),
  thumb: 'news/17.webp',
};
